import React from "react";
import styled from "styled-components";

const IosCheckBox = ({
  children,
  checked = false,
  text = "",
  id = "ios-checkbox",
  onChange = () => {},
  ...rest
}) => {
  return (
    <Label className="container" for={id}>
      <Input id={id} type="checkbox" onChange={onChange} checked={checked} {...rest}/>
      <Checkmark className="checkmark"></Checkmark>
      {text ? <TextWrapper>{text}</TextWrapper> : null}
      {children}
    </Label>
  )
};

export default IosCheckBox;

const Label = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 0px;
  padding-bottom: 0px;
  line-height: 20px;
  margin-right: 0px;
  font-size: inherit;
  user-select: none;
  color: #201f1e;
  font-weight: normal;
  cursor: pointer;

  .regsitration-terms {
    margin-left: 1rem;
    font-size: 1rem;
  }

  input:checked ~ .checkmark {
    background-color: #17bed0;
    border: none;

    &:after {
      display: block;
    }
  }
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

const TextWrapper = styled.div`
  margin-left: 1.25rem;
  font-size: 1rem;
`;

const Checkmark = styled.span`
  position: relative;
  top: 0px;
  left: 0px;
  flex-shrink: 0;
  height: 20px;
  width: 20px;
  border-radius: 3px;
  background-color: #fff;
  border: solid 1px #605e5c;
  box-shadow: 0 0.5px 1px 0 rgba(0, 0, 0, 0.28);

  &:after {
    content: "";
    position: absolute;
    display: none;
    left: 7px;
    top: 3px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;
